import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiMoreVertical, FiEdit, FiTrash2 } from 'react-icons/fi';

const expenseItem = ({ data, index, remove, link, elRef }) => {
    const [toggle, setToggle] = useState('none');
    console.log(data);

    return (
        <tr onClick={() => link(data.id)} ref={elRef}>
            <td>{index + 1}</td>
            <td><Link to={`/expenses/${data.id}`}>{data.name}</Link></td>
            <td>{new Date(data.createdAt).toLocaleString()}</td>
            <td>{data.amount} <sup><small>{data.currency}</small></sup> </td>
            <td>{data.type}</td>
            <td className="d-flex">
                <FiMoreVertical onClick={(event) => {
                    event.stopPropagation();
                    setToggle(toggle === 'none' ? 'block' : 'none')
                }} />
                <span id="actions-link" style={{ display: toggle }}>
                    <Link
                        to={`/expenses/${data.id}/edit`}
                        className="badge m-2 badge-sm badge-info"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <FiEdit />
                    </Link>
                    <button
                        className="badge m-2 badge-sm badge-danger"
                        onClick={(e) => {
                            e.stopPropagation()
                            remove(data.id)
                        }
                        }
                    >
                        <FiTrash2 />
                    </button>
                </span>
            </td>
        </tr >
    );
}

export default expenseItem;